import React, { Fragment, useEffect, useState } from 'react'
import { graphql, useQuery } from 'react-apollo'
import {
  Button, Row, Col,
  Layout, Table,
} from 'antd'

import reportDistrictCount from '../graphql/queries/reportCountDistrict'

const {
  Header, Footer, Sider, Content,
} = Layout

const columns = [
  {
    title: 'ตำบล',
    dataIndex: 'district',
    align: 'center',
    className: 'headercolor',
  },
  {
    title: 'จำนวนผู้สมัคร (คน)',
    dataIndex: 'count',
    key: '',
    align: 'center',
    className: 'headercolor',
    defaultSortOrder: 'descend',
    sorter: (a, b) => (a.isTotal || b.isTotal ? 0 : (a.count - b.count)),
    render: record => (`${record.toLocaleString() }`),
  },
  {
    title: 'ระยะวิ่งสะสม (กม.)',
    dataIndex: 'distance',
    key: '',
    align: 'center',
    className: 'headercolor',
    sorter: (a, b) => (a.isTotal || b.isTotal ? 0 : (a.distance - b.distance)),
    render: record => (`${record.toLocaleString(undefined, { minimumFractionDigits: 2 }) }`),
  },
]

const AmphoeCount = (props) => {
  // const {
  //   data = { reportCountProvince: [] }, loading, error,
  // } = useQuery(reportProvinceCount, {
  //   variables: { slug: 'nscth' },
  // })
  const {
    data = { reportCountDistrict: [] }, loading,
  } = useQuery(reportDistrictCount, {
    variables: { slug: 'nscth', province: props.match.params.province, amphoe: props.match.params.amphoe },
  })
  const locale = {
    emptyText: 'fetching data',
  }
  let reportSumDistrict = {
    district: 'รวม',
    count: 0,
    distance: 0,
  }
  if (!loading) {
    const total = data.reportCountDistrict.reduce((totalRecord, record) => ({
      count: totalRecord.count + record.count,
      distance: totalRecord.distance + record.distance,
    }), {
      count: 0,
      distance: 0,
    }) // { count, distance }
    console.log({ total })
    reportSumDistrict = {
      district: 'รวม', count: total.count, distance: total.distance, isTotal: true,
    }
  }
  const reportSumAllDistrict = [...data.reportCountDistrict, reportSumDistrict]

  return (
    <Table
          // rowSelection={rowSelection}
      dataSource={reportSumAllDistrict}
      columns={columns}
      locale={locale}
      rowKey="amphoe"
      pagination={false}

          // onChange={onTableChange}
      loading={loading}
      bordered
    />

  )
}
export default AmphoeCount
